export class MotifModificationMessages {
	
	public input ='motif_modification.input'

	constructor() {}
}
